import { render } from "./BookService.vue?vue&type=template&id=4c58574c&scoped=true"
import script from "./BookService.vue?vue&type=script&lang=js"
export * from "./BookService.vue?vue&type=script&lang=js"

import "./BookService.vue?vue&type=style&index=0&id=4c58574c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c58574c"]])

export default __exports__